import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import { RouterView } from "vue-router";
import CsrfContainer from "@/components/CsrfContainer.vue";
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(CsrfContainer, null, {
                default: _withCtx(() => [
                    _createVNode(_unref(RouterView), null, {
                        default: _withCtx(({ Component }) => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
